module.exports = __webpack_public_path__ + "static/media/saraswantmaa.7e2f44a6.jpg";